export const SEVERITY_MAP = {
  Critical:
    "Severe issues requiring immediate attention, likely allow easy remote exploitation with severe consequences",
  High: "Significant issues that likely lead to system compromise and require prompt attention",
  Medium:
    " Issues that could pose a threat but may be difficult to exploit or have limited impact",
  Low: "Issues with minimal impact, likely requiring specific conditions or local access to exploit",
  Info: "Informational findings that don't pose a direct security risk but may be useful for awareness",
}

export const STATUS_MAP = {
  Open: "Potentially legitimate issue which requires further investigation or action to fix",
  Resolved:
    "Legitimate issue which has been fixed and requires no further immediate action",
  "No Status": "",
  "Not Relevant": "",
}

export const SEVERITY_PRIORITY: Record<string, number> = {
  Critical: 1,
  High: 2,
  Medium: 3,
  Low: 4,
  Info: 5,
}

export const STATUS_PRIORITY: Record<string, number> = {
  Open: 1,
  Resolved: 2,
  "Not Relevant": 3,
  "No Status": 4,
}
